import { Collapse } from "@mui/material";
import ChevronIcon from "assets/icons/ChevronIcon";
import { SearchIcon2 } from "assets/icons/SearchIcon";
import { useEffect, useState } from "react";

type ArchiveSidebarProps = {
  item: {name: string, model: string}[];
  loading: boolean;
  activeArchive?: {name: string, model: string};
  setActiveArchive: (data?: {name: string, model: string}) => void;
};

export const ArchiveSidebar = ({
  item = [],
  loading,
  activeArchive,
  setActiveArchive,
}: ArchiveSidebarProps) => {
  const [sidebarItem, setSidebarItem] = useState(item);
  const [archiveExpand, setArchiveExpand] = useState(true);
  const [searchValue, setSearchValue] = useState("");

  const onExpandArchive = () => {
    setArchiveExpand(!archiveExpand);
  };

  useEffect(() => {
    const filteredItems = item.filter((i) => i.name.includes(searchValue));
    setSidebarItem(filteredItems);
  }, [searchValue, item]);

  return (
    <div className="flex flex-col w-1/4 h-full overflow-hidden">
      <div className="flex flex-row items-center px-4 w-full h-10 rounded-md border border-[#c2d1e3] mb-4">
        <SearchIcon2 color="#aeaeae" scale={1.2} />
        <input
          className="px-3 text-blue-1"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          style={{
            width: "100%",
            border: 0,
            outline: 0,
            background: "transparent",
          }}
          placeholder="جستجو در آرشیو..."
        />
      </div>
      <div className="flex flex-col overflow-y-auto w-full overflow-x-hidden h-full  ">
        <div className="flex flex-row w-full items-center justify-between">
          <div onClick={onExpandArchive} className="flex flex-row items-center gap-2 p-2 cursor-pointer mb-2">
            <ArchiveIcon />
            <span className="text-blue-1 font-IRANSans text-sm font-normal">آرشیو</span>
          </div>
          <ChevronIcon rotate={archiveExpand ? "top" : undefined} color={"#6B7888"} />
        </div>
        {loading ? (
          <div className="flex w-full h-full items-center justify-center">
            <span>در حال دریافت اطلاعات ...</span>
          </div>
        ) : (
          <Collapse in={archiveExpand}>
            <div className="flex w-full flex-col transition-all duration-500">
              {sidebarItem.map((i, index) => (
                <div
                  onClick={() => {
                    setActiveArchive(i);
                  }}
                  key={index}
                  className="flex flex-row w-full items-center justify-between"
                >
                  <div className="flex flex-row items-center gap-2 py-2 pr-10 cursor-pointer mb-2">
                    <FolderIcon active={i === activeArchive} />
                    <span
                      className={` ${
                        i === activeArchive ? "text-blue-1" : "text-[#6B7888]"
                      }  font-IRANSans text-sm font-normal`}
                    >
                      {i.name}
                    </span>
                  </div>
                  {i === activeArchive && <ChevronIcon rotate={"left"} color={"#6B7888"} />}
                </div>
              ))}
            </div>
          </Collapse>
        )}
      </div>
    </div>
  );
};

const ArchiveIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M20 11H4M20 11C21.1046 11 22 11.8954 22 13V17C22 19.2091 20.2091 21 18 21H6C3.79086 21 2 19.2091 2 17V13C2 11.8954 2.89543 11 4 11M20 11V9C20 7.89543 19.1046 7 18 7M4 11V9C4 7.89543 4.89543 7 6 7M18 7H6M18 7V5C18 3.89543 17.1046 3 16 3H8C6.89543 3 6 3.89543 6 5V7M10 14H14"
      stroke="#1062D0"
      strokeWidth="1.5"
      stroke-linecap="round"
    />
  </svg>
);

const FolderIcon = ({ active }: { active: boolean }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18" fill="none">
    <path
      d="M19.25 2.25H9.155L8.3225 1.005C8.11711 0.695822 7.83843 0.442258 7.51128 0.266906C7.18413 0.0915542 6.81868 -0.000138431 6.4475 1.56867e-07H2.75C2.15326 1.56867e-07 1.58097 0.237053 1.15901 0.65901C0.737053 1.08097 0.5 1.65326 0.5 2.25V15.75C0.5 16.3467 0.737053 16.919 1.15901 17.341C1.58097 17.7629 2.15326 18 2.75 18H19.25C19.8467 18 20.419 17.7629 20.841 17.341C21.2629 16.919 21.5 16.3467 21.5 15.75V4.5C21.5 3.90326 21.2629 3.33097 20.841 2.90901C20.419 2.48705 19.8467 2.25 19.25 2.25ZM20 15.75C20 15.9489 19.921 16.1397 19.7803 16.2803C19.6397 16.421 19.4489 16.5 19.25 16.5H2.75C2.55109 16.5 2.36032 16.421 2.21967 16.2803C2.07902 16.1397 2 15.9489 2 15.75V2.25C2 2.05109 2.07902 1.86032 2.21967 1.71967C2.36032 1.57902 2.55109 1.5 2.75 1.5H6.4475C6.57103 1.50064 6.69249 1.53178 6.80109 1.59066C6.90969 1.64954 7.00206 1.73433 7.07 1.8375L7.9025 3.0825C8.03994 3.28851 8.22626 3.45728 8.44481 3.57376C8.66336 3.69023 8.90735 3.75078 9.155 3.75H19.25C19.4489 3.75 19.6397 3.82902 19.7803 3.96967C19.921 4.11032 20 4.30109 20 4.5V15.75ZM8 13.5C8 13.6989 7.92098 13.8897 7.78033 14.0303C7.63968 14.171 7.44891 14.25 7.25 14.25H4.25C4.05109 14.25 3.86032 14.171 3.71967 14.0303C3.57902 13.8897 3.5 13.6989 3.5 13.5C3.5 13.3011 3.57902 13.1103 3.71967 12.9697C3.86032 12.829 4.05109 12.75 4.25 12.75H7.25C7.44891 12.75 7.63968 12.829 7.78033 12.9697C7.92098 13.1103 8 13.3011 8 13.5Z"
      fill={active ? "#1062D0" : "#6B7888"}
    />
  </svg>
);
